import React, { useMemo } from 'react'
import { useHtmlClassService } from '../../../_core/MetronicLayout'
import SubMenu from './SubMenu'
import * as paths from '../../../../../app/constants/path'
import { appConfig } from '../../../../../app/constants/app-config'
import { ROLE } from '../../../../../app/services/user/user-typed'
import { Authorize } from '../../../../../app/components/Authorize'
type OfficerMenuProp = {
  isActive: boolean
}

export function OfficerMenu({ isActive }: OfficerMenuProp) {
  const uiService = useHtmlClassService()
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes('aside_menu'),
      ulClasses: uiService.getClasses('aside_menu_nav', true),
      asideClassesFromConfig: uiService.getClasses('aside_menu', true),
    }
  }, [uiService])

  //

  return (
    <div className={`tab-pane fade ${isActive && 'show active'}`}>
      <div className="aside-menu-wrapper flex-column-fluid px-10 py-5">
        {/* begin::Menu Container */}
        <div
          id="kt_aside_officer_menu"
          data-menu-vertical="1"
          className={`aside-menu  min-h-lg-800px ${layoutProps.asideClassesFromConfig}`}
          {...layoutProps.asideMenuAttr}
        >
          {/* begin::Menu Nav */}
          <ul className={`menu-nav ${layoutProps.ulClasses}`}>
            {/*begin::1 Level*/}
            <SubMenu title="Users" to="/users" />
            <Authorize role={ROLE.MANAGER}>
              <SubMenu title="Notification" to="/notification" />
            </Authorize>
            <SubMenu title="Ports" to="/ports" />
            <SubMenu title="Kyc" to="/ekycs" />
            <SubMenu title="Transaction" to="/transactions" />
            <Authorize role={ROLE.MANAGER}>
              <SubMenu title="BankAccount" to={paths.bankAccounts()} />
            </Authorize>
            <Authorize role={ROLE.MANAGER}>
              <SubMenu title="Banner" to={paths.banner()} />
            </Authorize>
            <Authorize role={ROLE.MANAGER}>
              <SubMenu title="Campaign" to={paths.campaign()} />
            </Authorize>
            <Authorize role={ROLE.MANAGER}>
              <SubMenu title="Category" to={paths.category()} />
            </Authorize>
            {appConfig.ENABLE_FEATURE_ARTICLE && (
              <Authorize role={ROLE.ADMIN}>
                <SubMenu title="Article" to={paths.article()} />
              </Authorize>
            )}
            {appConfig.ENABLE_FEATURE_GIVEAWAY && (
              <Authorize role={ROLE.ADMIN}>
                <SubMenu title="Reward" to={paths.rewards()} />
              </Authorize>
            )}

            {appConfig.ENABLE_FEATURE_GOLD_TOP_UP && (
              <Authorize role={ROLE.SUPER_ADMIN}>
                <SubMenu title="GoldTopUp" to={paths.goldTopUp()} />
              </Authorize>
            )}
            {appConfig.ENABLE_FEATURE_SELL_LIMIT && (
              <Authorize role={ROLE.ADMIN}>
                <SubMenu title="Sell Limit" to={paths.sellLimit()} />
              </Authorize>
            )}
            <Authorize role={ROLE.MANAGER}>
              <SubMenu title="Tag" to={paths.tag()} />
            </Authorize>
            <Authorize role={ROLE.MANAGER}>
              <SubMenu title="TopDeal" to={paths.topDeal()} />
            </Authorize>
            <SubMenu title="Dca" to={paths.dca()} />

            {appConfig.ENABLE_FEATURE_IMPORT_DCA && (
              <Authorize role={ROLE.FINANCE}>
                <SubMenu title="Bulk Dca" to={paths.bulkDca()} />
              </Authorize>
            )}

            {/*end::1 Level*/}
          </ul>

          {/* end::Menu Nav */}
        </div>
        {/* end::Menu Container */}
      </div>
    </div>
  )
}
